import axios from "axios";
import i18next from "i18next";
import _ from "lodash";
import { Config } from "../config/Config";
import { notifyExternally } from "../context/notification";
import { routes } from "../routes";
import { getToken, removeToken } from "./auth";

let numberOfApiCalls = 0;

const jwtInterceptor = async config => {
  const shouldShowLoader = config.showLoader !== false;

  if (shouldShowLoader) {
    document.body.classList.add("loading-indicator");
    numberOfApiCalls++;
  }
  const token = getToken();
  config.headers = {
    ...config.headers,
    ...{ "Accept-Language": i18next.language },
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  config.metadata = { showLoader: shouldShowLoader };
  return config;
};

// redirects user to login page on 401 error
const onAuthErrorRedirect = async error => {
  const response = _.get(error, "response");
  if (response && response?.status === 401) {
    // log user out
    removeToken();

    // redirect to login page
    window.location.href = routes.login.getPath(null, {
      from: window.location.href,
    });
  }
};

export const appendInterceptor = axiosInstance => {
  axiosInstance.interceptors.request.use(jwtInterceptor);
  axiosInstance.interceptors.response.use(
    f => {
      if (f?.config?.metadata?.showLoader) {
        --numberOfApiCalls;
        if (numberOfApiCalls === 0) {
          document.body.classList.remove("loading-indicator");
        }
      }
      return f;
    },
    error => {
      // noinspection JSIgnoredPromiseFromCall
      onAuthErrorRedirect(error);
      if (error?.config?.metadata?.showLoader) {
        --numberOfApiCalls;
        if (numberOfApiCalls === 0) {
          document.body.classList.remove("loading-indicator");
        }
        document.body.classList.remove("loading-indicator");
      }
      document.body.classList.remove("loading-indicator");
      const response = _.get(error, "response");

      const message =
        response?.data?.message ||
        response?.data?.error ||
        response?.data?.msg ||
        "Network error occurred";

      const shouldNotify = error?.config?.skipNotification !== true;
      if (shouldNotify) {
        notifyExternally(message, "error");
      }

      return Promise.reject(error);
    }
  );
};

export const axiosBaseConfig = {
  baseURL: process.env.REACT_APP_COACHING_WEB_API,
  //baseURL: "http://localhost:5000/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};
export const axiosScorecardConfig = {
  baseURL: process.env.REACT_APP_COACHING_SCORECARD_API,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  params: { client_id: Config.scorecardClientID },
};

export const apiRequest = axios.create(axiosBaseConfig);
export const scorecardApiRequest = axios.create(axiosScorecardConfig);
appendInterceptor(apiRequest);
